import { render, staticRenderFns } from "./MySwing.vue?vue&type=template&id=31691542&"
import script from "./MySwing.vue?vue&type=script&lang=js&"
export * from "./MySwing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports